import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMailBulk} from "@fortawesome/free-solid-svg-icons";
import {faTwitter} from "@fortawesome/free-brands-svg-icons";
import {Grid} from "@material-ui/core";
import HankaContentWindow from "./HankaContentWindow";
import BoothLogo from "./BoothLogo";
import {SectionProps} from "./Section";
import BoxEffect from "./BoxEffect";
import {BoothItems} from "../Data/BoothItems";


const HankaBumonSection:React.FC<SectionProps> = (props) => {
    const boothItems = BoothItems;
    return(
        <div className={"SectionBase"}>
            <div className={"SectionContent HankaBumon"}>
                <BoxEffect isActive={true} delay={0.0}>
                    <div className={"SectionTitle"}>
                        Label
                    </div>
                </BoxEffect>
                <div className={"SectionSubtitle"}>
                    汎化部門
                </div>
                <div className={"Padding10"}>
                    Boothにてシェーダーやツール類の頒布を行っています
                </div>
                <Grid container>
                    {
                        boothItems.map(
                            (e,i) => {
                                return(
                                    <HankaContentWindow color={i % 2 == 0 ? "#00b7fa" : "#fa003c"} item={e}/>
                                );
                            }
                        )
                    }
                </Grid>
                <BoothLogo/>
            </div>
        </div>
    );
};

export default HankaBumonSection;